// HM-600 iPad UX: 2 stati sidebar (espansa 240 / mini 64). Default per
// larghezza (>=1280 espansa, < 1280 mini = iPad), con override manuale
// persistito (localStorage 'hm.sidebar.collapsed') che ha priorita'.
import { useCallback, useEffect, useState } from 'react';

export type SidebarMode = 'expanded' | 'collapsed';
const KEY = 'hm.sidebar.collapsed';
const BREAKPOINT = 1280;

function readOverride(): boolean | null {
  if (typeof window === 'undefined') return null;
  const v = window.localStorage.getItem(KEY);
  if (v === 'true') return true;
  if (v === 'false') return false;
  return null;
}

function autoCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < BREAKPOINT;
}

function computeMode(override: boolean | null): SidebarMode {
  const collapsed = override ?? autoCollapsed();
  return collapsed ? 'collapsed' : 'expanded';
}

export function useResponsiveSidebar(): { mode: SidebarMode; toggle: () => void } {
  const [mode, setMode] = useState<SidebarMode>(() => computeMode(readOverride()));

  // Ricalcola su resize SOLO se non c'e' override manuale.
  useEffect(() => {
    function onResize() {
      if (readOverride() === null) setMode(computeMode(null));
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const toggle = useCallback(() => {
    setMode((prev) => {
      const next: SidebarMode = prev === 'expanded' ? 'collapsed' : 'expanded';
      window.localStorage.setItem(KEY, String(next === 'collapsed'));
      return next;
    });
  }, []);

  return { mode, toggle };
}
